// extracted by mini-css-extract-plugin
module.exports = {"root":"config-number_root_1JO2c"};